export default "__VITE_ASSET__3Obm17$C__"